import styled from 'styled-components'
import { titleColor } from '@edulastic/colors'

export const ActionContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0 20px 0;
`

export const ModalMessage = styled.p`
  color: ${titleColor};
`

export const Heading = styled.h2`
  font-size: 18px;
  font-weight: 600;
  margin: 0;
`
